import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { FamilySettingsConstants as ui } from '../../Config/UIConstants';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { colors } from '../../styles/colors';
import { largeShadow } from '../../styles/styleObjects';

interface IProps {
    store?: ApplicationStore;
}

@inject('store')
@observer
export class JoinedFamiliesTab extends React.Component<IProps> {
    private get store(): ApplicationStore {
        return this.props.store!;
    }

    private renderCellForPhotoStories(title: string) {
        return (
            <div style={styles.storyInfoContainer}>
                <p style={styles.storyText}>{title}</p>
            </div>
        );
    }

    public render() {
        return (
            <div style={styles.container}>
                {this.store.userFamilyStore.userFamilies.length === 0 ? (
                    <div style={styles.emptyFamiliesContainer}>
                        <p style={styles.warningText}>{ui.HAVENT_JOINED}</p>
                    </div>
                ) : (
                    <div style={styles.cellContainer}>
                        {this.store.userFamilyStore.userFamilies.map(family => {
                            return this.renderCellForPhotoStories(family.name);
                        })}
                    </div>
                )}
            </div>
        );
    }
}

const styles = {
    emptyFamiliesContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    } as React.CSSProperties,
    warningText: {
        opacity: 0.8,
        marginTop: 150
    },
    container: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center'
    } as React.CSSProperties,
    cellContainer: {
        width: 400,
        boxShadow: largeShadow,
        marginTop: 25
    },
    cancelButton: {
        width: 110,
        height: 35,
        backgroundColor: colors.ACTION_BAR
    },
    buttonTextCancel: {
        color: colors.CANCEL_TEXT,
        fontSize: 14
    },
    storyInfoContainer: {
        height: 70,
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: 30,
        paddingRight: 25,
        borderBottom: '1px solid #48A29B30',
        alignItems: 'center'
    } as React.CSSProperties,
    flex: {
        display: 'flex'
    },
    storyText: {
        color: '#423F4E',
        fontSize: 16
    }
};



// WEBPACK FOOTER //
// ./src/Pages/ProfileSettings/JoinedFamiliesTab.tsx